import { FormFieldType } from "@theme/ui-components/forms/form-field-type";
import ThemeInputText from "@theme/ui-components/inputs/ThemeInputText";
import ThemeSelect from "@theme/ui-components/selects/ThemeSelect";
import { SectionModel } from "../../../services/sections/models/section.model";

import * as Yup from "yup";
import ThemeButton from "@theme/ui-components/buttons/ThemeButton";

const CompanyManagerTableFormFields = (
  sectionList: SectionModel[],
  isLoading: boolean,
  setModalSectionAdd: (e: boolean) => void,
): FormFieldType[] => [
  {
    name: "id",

    chield(values, handleChange, handleBlur, formName) {
      return (
        <ThemeInputText
          name={this.name}
          value={values[formName]}
          onChange={handleChange}
          onBlur={handleBlur}
          type="hidden"
        />
      );
    },
  },
  {
    name: "name",
    label: "Adı",
    validation: Yup.string().required("Bu alan zorunlu."),
    chield(values, handleChange, handleBlur, formName) {
      return (
        <ThemeInputText
          name={this.name}
          value={values[formName]}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      );
    },
  },
  {
    name: "number",
    label: "Masa Numarası",
    validation: Yup.string().required("Bu alan zorunlu."),
    chield(values, handleChange, handleBlur, formName) {
      return (
        <ThemeInputText
          name={this.name}
          value={values[formName]}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      );
    },
  },
  {
    name: "sectionId",
    label: "Bölüm",
    validation: Yup.string().required("Bu alan zorunlu."),
    chield(values, handleChange, handleBlur, formName) {
      return (
        <div style={{ display: "flex", gap: 5 }}>
          <ThemeSelect
            name={this.name}
            value={values[formName]}
            onChange={handleChange}
            onBlur={handleBlur}
            optionLabel="name"
            optionValue="id"
            options={sectionList}
          />
          <ThemeButton
            onClick={() => {
              setModalSectionAdd(true);
            }}
            loading={isLoading}
            disabled={isLoading}
            icon={<i className="fa-duotone fa-plus"></i>}
          >
            Ekle
          </ThemeButton>
        </div>
      );
    },
  },
];

export { CompanyManagerTableFormFields };
